<!-- <div class="popup-card">
    <div class="popup-card__close">
        <ci-icon (click)="closeModal()" name="close" scale="1x" />
    </div>

    <div class="popup-card__image">
        <img [src]="popUp?.image?.[translate.currentLang]" />
    </div>

    <svg class="popup-card__wave" viewBox="0 0 400 80" preserveAspectRatio="none">
        <path d="M0,40 C60,80 140,0 220,60 C300,120 380,20 400,40 L400,80 L0,80 Z"></path>
    </svg>

    <div class="popup-card__content">
        <h6 class="ci-heading-h6-bold" [style.color]="popUp?.button_color">
            {{ popUp?.title?.[translate.currentLang] }}
        </h6>
        <p class="ci-paragraph-p1-regular" [style.color]="popUp?.button_color">
            {{ popUp?.description?.[translate.currentLang] }}
        </p>
    </div>

    <div class="popup-card__cta">
        <ci-button class="ci-btn-primary-m-filled" (click)="goToLogin()" type="button" [aria-label]="'Quiero mi pasaporte' | translate">
            {{ popUp?.button_text?.[translate.currentLang] ?? ('Quiero mi pasaporte' | translate) }}
        </ci-button>
    </div>
</div> -->

<div class="popup-card" [ngStyle]="{'--popup-img-url': 'url(' + popUp.header_image?.[translate.currentLang] + ')'}">
    <div class="popup-card__close">
        <ci-icon (click)="closeModal()" name="close" scale="1x" />
    </div>

    @if(popUp?.logo_image?.[translate.currentLang]){
        <div class="popup-card__logo">
            <img [src]="popUp.logo_image[translate.currentLang]" />
        </div>
    }

    @if(popUp?.title?.[translate.currentLang] || popUp?.description?.[translate.currentLang]){
        <div class="popup-card__content">
            @if(popUp?.title?.[translate.currentLang]){
                <h6 class="ci-heading-h6-bold" [style.color]="popUp?.text_color">
                    {{ popUp?.title?.[translate.currentLang] }}
                </h6>
            }
            @if(popUp?.description?.[translate.currentLang]){
              <p class="ci-paragraph-p1-regular" [style.color]="popUp?.text_color"
                [innerHTML]="popUp.description[translate.currentLang]">
              </p>
            }
        </div>
    }

    <div class="popup-card__cta">
        <ci-button class="ci-btn-primary-m-filled" (click)="goToLogin()" type="button" [aria-label]="'Quiero mi pasaporte' | translate">
            {{ popUp?.button_text?.[translate.currentLang] ?? ('Quiero mi pasaporte' | translate) }}
        </ci-button>
    </div>
</div>